<template>
  <div>
    <div class="px-4">
      <div class="body p-4">
        <span class="text-primary h2 d-flex align-items-center">
          <button
            @click="handleGoBack()"
            class="btn font-weight-bold btn-primary text-white btn-shadow me-3"
          >
            <i class="fa fa-arrow-left"></i>
          </button>
          <span class="text-gray"> Ver sócio</span>
        </span>
        <!-- Sócios -->
        <div class="d-flex justify-content-center mt-4" v-if="loaderActive">
          <div class="spinner-border text-primary spinner-border" role="status">
            <span class="visually-hidden">Aguarde...</span>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="card p-4 mt-4 text-start">
              <div class="p-2">
                <div class="row">
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-cidade" class="form-label">CPF</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-cpf"
                      class="form-control"
                      aria-describedby="input-cpf"
                      placeholder="Não informado"
                      v-model="partner.cpf"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-nome" class="form-label"
                      >Nome completo</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-nome"
                      class="form-control"
                      aria-describedby="input-nome"
                      placeholder="Não informado"
                      v-model="partner.fullname"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-text" class="form-label"
                      >Nome da mãe</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-mae"
                      class="form-control"
                      aria-describedby="input-mae"
                      placeholder="Não informado"
                      v-model="partner.mother_name"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-tel" class="form-label"
                      >Nome do pai</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-pai"
                      class="form-control"
                      aria-describedby="input-pai"
                      placeholder="Não informado"
                      v-model="partner.father_name"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-tel" class="form-label"
                      >Data de nascimento</label
                    >
                    <input
                      :disabled="true"
                      type="date"
                      id="input-birth"
                      class="form-control"
                      aria-describedby="input-birth"
                      placeholder="Não informado"
                      v-model="partner.date_birth"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-nacionalidade" class="form-label"
                      >Cidade/Município de nascimento + UF</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-nascionalidade"
                      class="form-control"
                      aria-describedby="input-nascionalidade"
                      placeholder="Não informada"
                      v-model="partner.birth_city"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-ethnicity" class="form-label"
                      >Etnia</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-ethnicity"
                      class="form-control"
                      aria-describedby="input-ethnicity"
                      placeholder="Não informado"
                      v-model="partner.ethnicity"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-gender" class="form-label">Gênero</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-gender"
                      class="form-control"
                      aria-describedby="input-gender"
                      placeholder="Não informado"
                      v-model="partner.gender"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-profissao" class="form-label"
                      >Profissão</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-profissao"
                      class="form-control"
                      aria-describedby="input-profissao"
                      placeholder="Não informado"
                      v-model="partner.profission"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-2">
                    <label for="input-status_civil" class="form-label"
                      >Estado civil</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-status_civil"
                      class="form-control"
                      aria-describedby="input-status_civil"
                      placeholder="Não informado"
                      v-model="partner.status_civil"
                    />
                  </div>
                  <div
                    class="col-lg-6 col-sm-12 text-primary mb-2"
                    v-show="
                      status_civiles.findIndex((status) => {
                        return status === partner.status_civil;
                      }) === 2
                    "
                  >
                    <label for="input-property_regimes" class="form-label"
                      >Regime de bens</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-property_regimes"
                      class="form-control"
                      aria-describedby="input-property_regimes"
                      placeholder="Não informado"
                      v-model="partner.marital_property_systems"
                    />
                  </div>

                  <hr class="my-4" />
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-rg" class="form-label"
                      >Registro Geral</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-rg"
                      class="form-control"
                      aria-describedby="input-rg"
                      placeholder="Não informado"
                      v-model="partner.rg_number"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-dt-oe" class="form-label"
                      >Data de expedição</label
                    >
                    <input
                      :disabled="true"
                      type="date"
                      id="input-dt-oe"
                      class="form-control"
                      aria-describedby="input-dt-oe"
                      placeholder="Não informado"
                      v-model="partner.rg_date"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-2">
                    <label for="input-oe" class="form-label"
                      >Órgão Expedidor</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-oe"
                      class="form-control"
                      aria-describedby="input-oe"
                      placeholder="Não informado"
                      v-model="partner.rg_emitter"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-2">
                    <label for="input-oe-uf" class="form-label">UF</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-oe-uf"
                      class="form-control"
                      aria-describedby="input-oe-uf"
                      placeholder="Não informado"
                      v-model="partner.rg_uf"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="card p-4 mt-4 text-start">
              <div class="p-2">
                <div class="row">
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-tel" class="form-label">Telefone</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-tel"
                      class="form-control"
                      aria-describedby="input-tel"
                      placeholder="Não informado"
                      v-model="partner.phone"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-2">
                    <label for="input-email" class="form-label">Email</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-email"
                      class="form-control"
                      aria-describedby="input-email"
                      placeholder="Não informado"
                      v-model="partner.email"
                    />
                  </div>
                  <hr class="my-4" />
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-pis" class="form-label"
                      >Número do NIT/PIS</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-pis"
                      class="form-control"
                      aria-describedby="input-pis"
                      placeholder="Não informado"
                      v-model="partner.pis_number"
                    />
                  </div>
                  <hr class="my-4" />
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-tel" class="form-label"
                      >Título de eleitor</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-te"
                      class="form-control"
                      aria-describedby="input-te"
                      placeholder="Não informado"
                      v-model="partner.voter_number"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-zn" class="form-label">Zona</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-zn"
                      class="form-control"
                      aria-describedby="input-zn"
                      placeholder="Não informada"
                      v-model="partner.voter_zone"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-2">
                    <label for="input-sec" class="form-label">Seção</label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-sec"
                      class="form-control"
                      aria-describedby="input-sec"
                      placeholder="Não informada"
                      v-model="partner.voter_section"
                    />
                  </div>
                  <hr class="my-4" />
                  <div class="col-lg-6 col-sm-12 text-primary">
                    <label for="input-irpf" class="form-label"
                      >Recibo do IRPF</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-irpf"
                      class="form-control"
                      aria-describedby="input-irpf"
                      v-model="partner.number_receita"
                      placeholder="Não informado"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary">
                    <label for="switch-irpf" class="form-label"
                      >Nunca declarei</label
                    >
                    <div class="form-check form-switch">
                      <input
                        :disabled="true"
                        class="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="switch-irpf"
                        v-model="switch_irpf"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card p-4 mt-4 text-start">
              <div class="p-2">
                <h4 class="text-gray text-disabled font-weight-light">
                  Endereço residencial completo do sócio
                </h4>
                <div class="d-flex flex-row mb-3 align-items-center">
                  <div class="row me-2">
                    <label for="input-cep p-0" class="form-label"
                      >Qual o CEP?</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-cep"
                      class="form-control mx-3"
                      aria-describedby="input-cep"
                      placeholder="Não informado"
                      v-model="andress.postal_code"
                    />
                  </div>
                  <div class="mt-4 ms-4">
                    <button
                      @click="getCep('model')"
                      class="btn font-weight-bold btn-primary text-white btn-shadow"
                    >
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-rua" class="form-label"
                      >Qual a rua?</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-rua"
                      class="form-control"
                      aria-describedby="input-rua"
                      placeholder="Não informada"
                      v-model="andress.street"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary">
                    <label for="input-bairro" class="form-label"
                      >Qual o bairro?</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-bairro"
                      class="form-control"
                      aria-describedby="input-bairro"
                      placeholder="Não informado"
                      v-model="andress.neighborhood"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-cidade" class="form-label"
                      >Qual a cidade?</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-cidade"
                      class="form-control"
                      aria-describedby="input-cidade"
                      placeholder="Não informada"
                      v-model="andress.city"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-estado" class="form-label"
                      >Qual o estado?</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-estado"
                      class="form-control"
                      aria-describedby="input-estado"
                      placeholder="Não informado"
                      v-model="andress.uf"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-nro" class="form-label"
                      >Qual o número?<span
                        v-tooltip="'Informe apenas o número, sem letras'"
                        ><i class="fas fa-info-circle ms-2"></i> </span
                    ></label>
                    <input
                      :disabled="true"
                      type="text"
                      id="input-nro"
                      class="form-control"
                      aria-describedby="input-nro"
                      placeholder="Não informado"
                      v-model="andress.number"
                    />
                  </div>
                  <div class="col-lg-6 col-sm-12 text-primary mb-4">
                    <label for="input-complemento" class="form-label"
                      >Complemento</label
                    >
                    <input
                      :disabled="true"
                      type="text"
                      id="input-complemento"
                      class="form-control"
                      aria-describedby="input-complemento"
                      placeholder="Não informado"
                      v-model="andress.complement"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="card mt-4 cursor-auto">
              <div class="d-flex justify-content-center">
                <span
                  class="mb-4 rounded-circle shadow mt-n5"
                  style="width: min-content; padding: 2rem"
                >
                  <i class="fa fa-id-card-clip fa-5x text-secondary"></i>
                </span>
              </div>
              <div class="row text-center">
                <div class="col-12 h4">
                  <b>{{ partner.fullname }}</b>
                </div>
                <div class="col-12">
                  <b>CPF:</b> {{ partner.cpf || "Não informado" }}
                </div>
                <div class="col-12">
                  <b>Email:</b>
                  {{ partner.email || "Não informado" }}
                </div>
                <div class="col-12">
                  <b>Telefone:</b> {{ partner.phone || "Não informado" }}
                </div>
                <div class="col-12">
                  <b>Cargo:</b>
                  {{ partner.company_function || "Não informado" }}
                </div>
                <span class="d-flex justify-content-center">
                  <hr class="my-4" style="width: 90%" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
  name: "partner-view",
  data() {
    return {
      status_civiles: [
        "",
        "Solteiro(a)",
        "Casado(a)",
        "Viúvo(a)",
        "Separado(a)",
        "Divorciado(a)",
      ],
      property_regimes: [
        "Comunhão Parcial de Bens",
        "Comunhão Universal de Bens",
        "Separação Legal de Bens",
        "Participação Final nos Aquestos",
      ],
      switch_irpf: false,
      partner: "",
      andress: "",
      genders: ["Feminino", "Masculino", "Outro"],
      etnias: [
        "Pardo(a)",
        "Branco(a)",
        "Negro(a)",
        "Indígena(a)",
        "Amarelo(a)",
        "Prefiro não informar",
      ],
      loaderActive: false,
    };
  },
  async mounted() {
    await this.loadEmployee();
  },
  methods: {
    handleGoBack() {
      const previousUrl = localStorage.getItem("previousUrl");
      if (previousUrl) {
        this.$router.push(previousUrl);
      } else {
        this.$router.push("/");
      }
    },
    showLoader() {
      this.loaderActive = !this.loaderActive;
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getUTCFullYear();
      let day = newDate.getUTCDate();
      let month = newDate.getUTCMonth() + 1;
      if (month < "10") {
        month = "0" + month;
      }
      if (day < "10") {
        day = "0" + day;
      }
      //yyyy-MM-dd
      return `${year}-${month}-${day}`;
    },
    async loadEmployee() {
      try {
        this.showLoader();
        const { data } = await api.get(
          `/user-accountant/partners/${this.$route.params.id}/getItem`
        );
        data.date_birth = this.formatDate(data.date_birth);
        data.rg_date = this.formatDate(data.rg_date);
        this.partner = data;
        if (this.partner.marital_property_systems) {
          this.partner.marital_property_systems =
            this.property_regimes[
              this.property_regimes.findIndex((regime) => {
                return regime === data.marital_property_systems;
              }) + 1
            ];
        }
        if (this.partner.gender)
          this.partner.gender = this.genders[parseInt(this.partner.gender) - 1];
        if (this.partner.ethnicity)
          this.partner.ethnicity =
            this.etnias[parseInt(this.partner.ethnicity)];
        if (this.partner.status_civil)
          this.partner.status_civil =
            this.status_civiles[parseInt(this.partner.status_civil)];
        if (data.andress) {
          this.andress = data.andress;
        }

        this.showLoader();
      } catch (e) {
        let message =
          "Ocorreu um erro ao carregar as informações do sócio. Recarregue a página e tente novamente.";
        if (e.response.data.message) message = e.response.data.message;
        toast.error(message);
      }
    },
  },
};
</script>
<style scoped>
.close-button {
  border: none;
  background-color: transparent;
}
.collection {
  border: none;
}
.item-title:hover {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.relative {
  position: relative;
}
.badge {
  border-radius: 2px;
  font-weight: 300;
}
.collection-title {
  margin: 0;
}
.rounded-circle {
  background-color: rgb(2, 0, 125);
}
</style>
